import { Action, handleActions } from 'redux-actions'
import { CompanyId, CompanyStatistics } from '../../../services/api.types'
import { getSpecificCompanyStatisticsSuccess, setSelectedCompanyId } from './StatisticsActions'

class State {
  companyStatistics: CompanyStatistics = {
    companyEnergyStatistics: { bigMacs: 0.0, totalKcal: 0.0 },
    companyIntensiveMinutesStatistics: { co2EmissionPrevented: 0.0, totalMin: 0.0 },
    companyStepsStatistics: { totalSteps: 0.0, roundsAroundTheWorld: 0.0, totalDistance: 0.0 },
  }
  selectedCompanyId: CompanyId | null = null
}

export const statistics = handleActions<State, any>(
  {
    [String(getSpecificCompanyStatisticsSuccess)]: (state: State, { payload }: any): State => ({
      ...state,
      companyStatistics: payload,
    }),
    [String(setSelectedCompanyId)]: (state: State, action: Action<CompanyId>): State => ({
      ...state,
      selectedCompanyId: action.payload,
    }),
  },
  new State(),
)

export { State as StatisticsState }
